import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { forwardRef, useState } from 'react';
import { Box, Typography, Slider } from '@mui/material';
import { SliderLabelValue } from './atoms.js';

var ZigSlider = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.labels, labels = _c === void 0 ? {} : _c, prefixId = _a.prefixId, _d = _a.className, className = _d === void 0 ? "" : _d, valueLabelFormat = _a.valueLabelFormat, _e = _a.labelFormat, labelFormat = _e === void 0 ? true : _e, props = __rest(_a, ["labels", "prefixId", "className", "valueLabelFormat", "labelFormat"]);
    var _f = useState(props.defaultValue), internalValue = _f[0], setInternalValue = _f[1];
    var value = (_b = props.value) !== null && _b !== void 0 ? _b : internalValue;
    var valueLabelFormatDefaulted = valueLabelFormat;
    if (!valueLabelFormatDefaulted && (!props.max || props.max === 100)) {
        valueLabelFormatDefaulted = function (value) { return "".concat(value, "%"); };
    }
    var labelFormatDefaulted = valueLabelFormatDefaulted;
    if (labelFormat && labelFormat !== true) {
        labelFormatDefaulted = labelFormat;
    }
    var start = labels.start, end = labels.end, _g = labels.showValues, showValues = _g === void 0 ? true : _g, labelsAbove = labels.labelsAbove;
    var showLabels = start || end;
    var marks = [25, 50, 75].map(function (percentage) { return ({
        value: (percentage * (props.max || 100)) / 100,
    }); });
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column", id: prefixId && "".concat(prefixId, "__container"), gap: "10px", width: 1, className: className, ref: ref },
        (labels === null || labels === void 0 ? void 0 : labels.top) && (React__default.createElement(Typography, { color: "neutral200", id: prefixId && "".concat(prefixId, "__title") }, labels === null || labels === void 0 ? void 0 : labels.top)),
        React__default.createElement(Box, { display: "flex", width: 1, gap: 1, alignItems: "center", pt: showLabels && labelsAbove !== false ? 3 : 0, pb: showLabels && labelsAbove === false ? 3 : 0, position: "relative" },
            React__default.createElement(Box, { display: "flex", width: 1, gap: "13px", alignItems: "center" },
                showValues && (React__default.createElement(SliderLabelValue, { prefixId: prefixId && "".concat(prefixId, "__label-start"), side: "start", labels: labels, min: props.min, max: props.max, value: value, labelFormat: labelFormatDefaulted })),
                React__default.createElement(Slider, __assign({ id: prefixId && "".concat(prefixId, "__slider"), marks: marks, track: Array.isArray(value) ? "normal" : false, valueLabelDisplay: labels.invertSliderValues ? "off" : "auto", valueLabelFormat: valueLabelFormatDefaulted, sx: {
                        width: "auto",
                        flex: 1,
                        ".MuiSlider-track": {
                            opacity: 0.7,
                        },
                    }, onChange: function (e, v, a) {
                        var _a;
                        if (props.defaultValue !== undefined) {
                            setInternalValue(v);
                        }
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e, v, a);
                    } }, props)),
                showValues && (React__default.createElement(SliderLabelValue, { prefixId: prefixId && "".concat(prefixId, "__label-end"), side: "end", labels: labels, min: props.min, max: props.max, value: value, labelFormat: labelFormatDefaulted }))))));
});

export { ZigSlider as default };
